import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/lian-ai', label: '分类大全' },
  { path: '/category/dong-zuo', label: '排行榜' },
  { path: '/category/qi-huan', label: '最新更新' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className={`font-heading text-2xl font-bold tracking-tight transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-white'}`}>
              51漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-accent-500 ${
                  location.pathname === link.path
                    ? scrolled ? 'text-accent-500' : 'text-accent-400'
                    : scrolled ? 'text-foreground-700' : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 bg-accent-500 text-white hover:bg-accent-600 cursor-pointer`}
            >
              立即阅读
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-950' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-accent-500'
                    : 'text-foreground-700 hover:text-accent-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-4 pt-3">
              <Link
                to="/about"
                onClick={() => setMobileOpen(false)}
                className="inline-block px-5 py-2 rounded-full text-sm font-medium bg-accent-500 text-white cursor-pointer"
              >
                立即阅读
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}